import cx from 'clsx';
import type { HTMLProps, ReactElement } from 'react';
import styles from './highlight.module.css';

export interface HighlightProps extends HTMLProps<HTMLSpanElement> {
  text: string;
  className?: string;
}

export function BadgeHighlight({ text, className, ...props }: HighlightProps): ReactElement {
  return (
    <span
      className={cx(styles.highlight, 'caption', className)}
      data-test-badge-highlight=""
      {...props}
    >
      {text}
    </span>
  );
}
